module.exports = __webpack_public_path__ + "static/img/IMG_20240209_174257.a0b0f649.jpg";